module.exports = __webpack_public_path__ + "static/media/logo.dc74549c.png";